import Decimal from "decimal.js";

const useBigNumber = () => {
  const toBigNumber = (value: string) => {
    return new Decimal(value);
  };

  const multiply = (value1: Decimal, value2: Decimal) => {
    return value1.times(value2);
  };

  const equals = (value1: Decimal, value2: Decimal) => {
    return value1.equals(value2);
  };

  const plus = (value1: Decimal, value2: Decimal): Decimal => {
    return value1.plus(value2);
  };

  const isZero = (value: Decimal): boolean => {
    return value.isZero();
  };

  return { toBigNumber, multiply, equals, plus, isZero };
};

export default useBigNumber;
